import {trimString} from '../exports/trimString';

export default {
  init() {
    /*
     * SELECTORS
     */
    let listingEventsLabel = document.querySelectorAll('.single-event .heading-3');
    /*
     * EVENTS
     */
    /*
     * ACTIONS
     */
    trimString(listingEventsLabel, 55);
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/events.js